
export  const CreateNewItemNewsLetter = 2; 
export  const CreateNewItemContactUs = 1; 

/***** HOME PAGE *****/
    /** he **/
        export const NewsLetterTitleHE = 'כניסה לרשימת דיוור';
        export const NewsLetterSubTitleHE = 'קבלת עדכונים לגבי הכרזות על פעילי וארגוני טרור, צווי תפיסה ופרסומים באתר';
        export const NewsLetterBtnHE = 'הרשמה';
/** en **/
export const NewsLetterTitleEn = 'Register to Newsletter';
export const NewsLetterSubTitleEn = 'Get Updates about Terror Organizations';
export const NewsLetterBtnEn = 'Register';
    /** ar **/

/***** INNER PAGE *****/
    /** he **/
    /** en **/
    /** ar **/


/***** ALL NEWS PAGE *****/
    /** he **/
    /** en **/
    /** ar **/


/***** CONTACT-US PAGE *****/
    /** he **/
        export const ContactUsTitleHE = 'ניתן להשאיר פרטים וניצור איתך קשר';
        export const ContactUsTitleHENew = 'ניתן להשאיר פרטים וניצור איתך קשר במידת הצורך';
    /** en **/
        export const ContactUsTitleEN = 'Please Leave your details and we will contact you';
        export const ContactUsTitleENNew = 'Please Leave your details and we will contact you if necessary';
    /** ar **/
        export const ContactUsTitleAR ='Please Leave your details and we will contact you';
        export const ContactUsTitleARNew ='يمكن ترك التفاصيل لنعاود الاتصال بك إذا لزم الأمر';